import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import cancelarReservasPedido from '../../actions/reserva/cancelarReservasPedido';
import {formatarReal} from '../../util/numberUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalConfirmacaoCancelamentoPedido extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoCancelamentoPedido')
      .modal('hide');
    $('#modalConfirmacaoCancelamentoPedido')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.props.cancelarReservasPedido(values.observacao, this.props.empresaSelecionada.id, this.props.pedido.id)
      .then(() => {
          showSuccessMsg('Pedido cancelado com sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirTaxaRemarcacao () {
    let taxa = 0.00;
    let valorTotal = 0.00;
    let estorno = 0.00;
    if (this.props.reservas) {
      this.props.reservas
        .forEach(reserva => {
          taxa += Number(reserva.custoCancelamento);
          valorTotal += formatarReal(reserva.taxaEmbarque) ? (Number(reserva.taxaEmbarque) + Number(reserva.valor)) : reserva.valor;
        })
      estorno = valorTotal - taxa;
    }

    return (
      <div className="vx-modal-finance-grid">
        <div className="vx-modal-finance-card">
          <span className="vx-modal-finance-label">Total</span>
          <span className="vx-modal-finance-value">
            {valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
          </span>
        </div>
        <div className="vx-modal-finance-card">
          <span className="vx-modal-finance-label">Taxa</span>
          <span className="vx-modal-finance-value">
            {taxa.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
          </span>
        </div>
        <div className="vx-modal-finance-card">
          <span className="vx-modal-finance-label">Estorno</span>
          <span className="vx-modal-finance-value">
            {estorno.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
          </span>
        </div>
      </div>
    )
  }

  exibirReservas () {
    return (
      <div className="vx-modal-reservas">
        <p className="vx-modal-reservas-label">Reservas do pedido</p>
        <ul className="vx-modal-reservas-list">
          {this.props.reservas.map(reserva => (
            <li key={reserva.id} className="vx-modal-reservas-item">
              <span className="material-icons">arrow_forward</span>
              <div>
                <div className="vx-modal-reservas-route">{reserva.descCidadeOrigem} → {reserva.descCidadeDestino}</div>
                <div className="vx-modal-reservas-pax">{reserva.passageiroDto.nome}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoCancelamentoPedido" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoCancelamentoPedido" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">cancel</span>
                Cancelar Pedido
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar">
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body">
                {this.props.reservas ? (
                  <React.Fragment>
                    {this.exibirTaxaRemarcacao()}
                    {this.exibirReservas()}
                    <p className="vx-modal-obs-label">Motivo do cancelamento</p>
                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea}
                           validate={[required]} className="form-control" label=""/>
                  </React.Fragment>
                ) : ''}
              </div>
              <div className="vx-modal-footer">
                <button id='cancelar' type="button" className="vx-modal-btn-fechar" data-dismiss="modal">
                  Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar" style={{background: '#e53935'}}>
                  <span className="material-icons" style={{fontSize: '16px'}}>check_circle</span>
                  Sim, cancelar
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    reservas: state.pedido ? state.pedido.reservas : [],
    pedido: state.pedido,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  cancelarReservasPedido
})(reduxForm({
  form: 'formularioCancelamentoPedido',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoCancelamentoPedido));
